import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobCard, KoobEmptyState, KoobPlaceholder } from '@koob/ui';
import DocumentListItem from './DocumentListItem';
import { getBookingDocument } from 'api/bookings';
import { getTripDocument } from 'api/trip';
import { decodeId } from 'utils';

export default function DocumentList({
  documents,
  bookingId,
  tripId,
  conversationId,
  isTrip = false,
}) {
  const { t } = useTranslation('booking');

  const getDocument = documentId => {
    if (isTrip) {
      return getTripDocument({ tripId, conversationId, documentId });
    }
    return getBookingDocument({ bookingId: decodeId(bookingId), documentId });
  };

  return (
    <KoobCard>
      {documents?.length > 0 ? (
        <div className="-my-5 flex flex-col divide-y">
          {documents.map((document, key) => (
            <DocumentListItem
              document={document}
              key={key}
              getDocument={getDocument}
            />
          ))}
        </div>
      ) : documents ? (
        <KoobEmptyState
          icon={<i className="fa-light fa-file" />}
          title={t('documents.empty')}
        />
      ) : (
        [...Array(5)].map((_e, key) => (
          <KoobPlaceholder className="h-12 my-1" key={key} />
        ))
      )}
    </KoobCard>
  );
}
